import {autorun} from "mobx";
import {O, RunInAction} from "web-vcore";
import {SessionLog} from "../../../UI/Tools/@Shared/BetweenSessionTypes/SessionLog.js";
import {store} from "../../index.js";
import {AudioFileEntry, GetAudioFileEntries_LowLevel, GetImageFileEntries_LowLevel, GetVideoFileEntries_LowLevel, ImageFileEntry, VideoFileEntry} from "../../../Utils/Bridge/Bridge_Native/MediaTypes.js";
import {AutoRun} from "../../../Utils/General/MobX.js";
import {ignore} from "mobx-sync";

export function GetCache() {
	return store.main.cache;
}

export class CacheState {
	@O @ignore accessor imageFiles_updatedRequestedAt = 0;
	@O @ignore accessor imageFiles: ImageFileEntry[] = [];

	@O @ignore accessor audioFiles_updatedRequestedAt = 0;
	@O @ignore accessor audioFiles: AudioFileEntry[] = [];

	@O @ignore accessor videoFiles_updatedRequestedAt = 0;
	@O @ignore accessor videoFiles: VideoFileEntry[] = [];
}

// todo: ensure that the case-sensitivity here matches with the query-based filtering done on android side, in its "Get[X]FileEntries" bridge-functions
export function GetImageFilesWithSubpath(subpath: string) {
	return GetCache().imageFiles.filter(a=>a.filePath.includes(subpath));
}
export function GetAudioFilesWithSubpath(subpath: string) {
	return GetCache().audioFiles.filter(a=>a.filePath.includes(subpath));
}
export function GetVideoFilesWithSubpath(subpath: string) {
	return GetCache().videoFiles.filter(a=>a.filePath.includes(subpath));
}

AutoRun({wait: 0}, ()=>{
	const cache = GetCache();
	const updateRequestedAt = cache.imageFiles_updatedRequestedAt; // read this, so that updating the field causes this autorun to re-execute
	const updateCallSuperseded = ()=>cache.imageFiles_updatedRequestedAt != updateRequestedAt;

	//const rootFolderToQuery = "/";
	const rootFolderToQuery = "Pictures/LF/";

	(async()=>{
		if (updateCallSuperseded()) return;
		const imageFiles = await GetImageFileEntries_LowLevel(rootFolderToQuery);
		if (updateCallSuperseded()) return;

		SessionLog(`Refreshed image-files cache, from android media store: ${imageFiles.length}`);
		RunInAction("CacheState_imageFiles_autorun", ()=>{
			cache.imageFiles = imageFiles;
		});
	})();
}, {name: "CacheState_imageFiles_autorun"});
AutoRun({wait: 0}, ()=>{
	const cache = GetCache();
	const updateRequestedAt = cache.audioFiles_updatedRequestedAt; // read this, so that updating the field causes this autorun to re-execute
	const updateCallSuperseded = ()=>cache.audioFiles_updatedRequestedAt != updateRequestedAt;

	(async()=>{
		if (updateCallSuperseded()) return;
		const audioFiles = await GetAudioFileEntries_LowLevel("/");
		if (updateCallSuperseded()) return;

		SessionLog(`Refreshed audio-files cache, from android media store: ${audioFiles.length}`);
		RunInAction("CacheState_audioFiles_autorun", ()=>{
			cache.audioFiles = audioFiles;
		});
	})();
}, {name: "CacheState_audioFiles_autorun"});
AutoRun({wait: 0}, ()=>{
	const cache = GetCache();
	const updateRequestedAt = cache.videoFiles_updatedRequestedAt; // read this, so that updating the field causes this autorun to re-execute
	const updateCallSuperseded = ()=>cache.videoFiles_updatedRequestedAt != updateRequestedAt;

	(async()=>{
		if (updateCallSuperseded()) return;
		const videoFiles = await GetVideoFileEntries_LowLevel("/");
		if (updateCallSuperseded()) return;

		SessionLog(`Refreshed video-files cache, from android media store: ${videoFiles.length}`);
		RunInAction("CacheState_videoFiles_autorun", ()=>{
			cache.videoFiles = videoFiles;
		});
	})();
}, {name: "CacheState_videoFiles_autorun"});